import { useMenuStore } from '@centric-os/stores/menus/use-menu-store';
import type { Menu, V2Menu, V3Menu } from '@centric-os/types';
import { isEmpty } from 'lodash-es';

export default () => {
  const useStationBrandMenus = async (
    stationMenus: V2Menu[],
    stationId: string,
  ): Promise<V3Menu[] | V2Menu> => {
    const menuStore = useMenuStore(`station-menu-${stationId}`);

    const filteredCentricMenus = stationMenus
      .filter((stationMenu: V2Menu) => stationMenu?.meta?.centricos)
      .map((centricMenu: V3Menu) => {
        return centricMenu.id;
      });

    if (isEmpty(filteredCentricMenus)) return stationMenus;

    const centricMenusMappedToBrands = await menuStore.getAllMenus(true, {
      params: {
        filter: { id: { $in: filteredCentricMenus } },
      },
    });

    const newStationMenus = stationMenus?.map((stationMenu: V2Menu): V2Menu | V3Menu => {
      if (!stationMenu?.meta?.centricos) return stationMenu;

      const mappedMenu = centricMenusMappedToBrands?.find((menu: Menu) => {
        return menu.id === stationMenu.id;
      });
      const mergedMenu = { ...stationMenu, ...mappedMenu };
      // @ts-expect-error FIXME: type not assignable
      return mergedMenu;
    });

    return newStationMenus;
  };
  return { useStationBrandMenus };
};
